<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <h3>基础</h3>
      <el-form-item label="工单编号" prop="sourceWorkOrderNo">
        <el-input v-model="search.sourceWorkOrderNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="回收订单" prop="sendBackOrderId">
        <el-input clearable v-model="search.sendBackOrderId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="回收码" prop="recycleCode">
        <el-input clearable v-model="search.recycleCode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="承运商" prop="transportCompanyNo">
        <el-select v-model="search.transportCompanyNo" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in carrierOption" :key="item.carrierNo" :label="item.carrierName" :value="item.carrierNo"> </el-option>
        </el-select>
      </el-form-item>
      <!-- 渠道来源 -->

      <el-form-item label="渠道来源" prop="salePlatformList">
        <el-select v-model="search.salePlatformList" placeholder="请选择" clearable style="width: 100%" :disabled="!!search.salePlatformType">
          <el-option v-for="(val, key) in salePlatformMap" :key="key" :label="val" :value="key"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="旧机条码所属销司" prop="saleCompanyNo">
        <el-select v-model="search.saleCompanyNo" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="(val, key) in regionOption" :key="key" :label="val.label" :value="val.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省" prop="warehouseAddrProvCode">
        <el-select v-model="search.warehouseAddrProvCode" placeholder="请选择" clearable style="width: 100%" @change="getTblCity">
          <el-option v-for="item in provinceList" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceCode" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="warehouseAddrCityCode">
        <el-select v-model="search.warehouseAddrCityCode" placeholder="请选择" clearable style="width: 100%" :disabled="!search.warehouseAddrProvCode">
          <el-option v-for="item in cityList" :key="item.cityCode" :label="item.cityName" :value="item.cityCode" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="旧机状态" prop="status">
        <el-select v-model="search.status" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="(val, key) in oldMachineMap" :key="key" :label="val" :value="key"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回收完成时间" prop="completeTime">
        <el-date-picker
          clearable
          v-model="completeTime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeCompleteTime"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 隐藏显示 -->
      <template v-if="showOtherSearch">
        <h3>结算</h3>
        <el-form-item label="网点所属销司" prop="regionNo">
          <!-- <el-input
            v-model="search.regionName"
            placeholder="请输入"
            clearable
          ></el-input> -->
          <el-select v-model="search.regionNo" placeholder="请选择" clearable style="width: 100%">
            <el-option v-for="(val, key) in regionOption" :key="key" :label="val.label" :value="val.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线上/线下渠道" prop="salePlatformType">
          <el-select v-model="search.salePlatformType" placeholder="请选择" clearable style="width: 100%" @change="changeSalePlatformType">
            <el-option v-for="item in salePlatformType" :key="item.value" :label="item.label" :value="item.value" style="width: 100%"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="旧机结算状态" prop="settlementStatus">
          <el-select v-model="search.settlementStatus" placeholder="请选择" clearable style="width: 100%">
            <el-option v-for="(val, key) in settlementStatusOption" :key="key" :label="val" :value="key"> </el-option>
          </el-select>
        </el-form-item>
        <h3>其他</h3>
        <el-form-item label="网点编号" prop="outletsNo">
          <el-input v-model="search.outletsNo" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item label="网点名称" prop="outletsName">
          <el-input v-model="search.outletsName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="归集仓" prop="warehouseName">
          <el-input v-model="search.warehouseName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="回收人员" prop="recycleName">
          <el-input v-model="search.recycleName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="旧机条码" prop="oldBarcode">
          <el-input v-model="search.oldBarcode" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="外机规格匹配" prop="oldMachineSpecMatch">
          <el-select v-model="search.oldMachineSpecMatch" placeholder="请选择" clearable style="width: 100%">
            <el-option v-for="(val, key) in oldMachineSpecMatchOption" :key="key" :label="val" :value="key" style="width: 100%"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批次号" prop="batchNumber">
          <el-input v-model="search.batchNumber" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="旧机品牌(工程师)" prop="engineerOldMachineBrand">
          <el-select v-model="search.engineerOldMachineBrand" placeholder="请选择" clearable style="width: 100%">
            <el-option label="格力品牌" value="GREE"> </el-option>
            <el-option label="非格力品牌" value="OTHER"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="再生资源入库(内)" prop="internalWarehousing">
          <el-select v-model="search.internalWarehousing" placeholder="请选择" clearable style="width: 100%">
            <el-option v-for="(val, key) in warehousingOption" :key="key" :label="val" :value="key"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="再生资源入库(外)" prop="externalWarehousing">
          <el-select v-model="search.externalWarehousing" placeholder="请选择" clearable style="width: 100%">
            <el-option v-for="(val, key) in warehousingOption" :key="key" :label="val" :value="key"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工程师鉴定时间" prop="workerAppraisalTime">
          <el-date-picker
            clearable
            v-model="workerAppraisalTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeWorkerAppraisalTime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="工单创建时间" prop="createdTime">
          <el-date-picker
            clearable
            v-model="createdTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeCreatedTime"
          >
          </el-date-picker>
        </el-form-item>
      </template>
    </el-form>
    <div class="show-other-search">
      <div v-if="showOtherSearch" @click="showOtherSearch = !showOtherSearch" class="show-other-search-btn"><i class="el-icon-arrow-up show-btn-icon"></i>收起</div>
      <div v-else @click="showOtherSearch = !showOtherSearch" class="show-other-search-btn"><i class="el-icon-arrow-down show-btn-icon"></i>展开</div>
    </div>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
      <el-button size="medium" @click="resetForm()">重置</el-button>

      <el-button size="medium" @click="exportExcel()">导出</el-button>
      <el-button size="medium" @click="BatchSettleStatus()">批量再生资源已结算</el-button>

      <div class="batch-storage-button">
        <file-upload ref="fileupload" @addUpload="importExcel" :title="'批量再生资源已入库'" />
      </div>

      <el-button size="medium" @click="downloadBatchStorageTemplate">批量入库模板下载</el-button>
      <el-button size="medium" type="primary" @click="openTable">结算单导出</el-button>
    </div>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="工单编号" prop="sourceWorkOrderNo" width="200"></el-table-column>
      <el-table-column label="工单类型" prop="serviceType" width="120">
        <template slot-scope="scope">
          {{ scope.row.serviceType | changeStatus(orderTypeOption) }}
        </template>
      </el-table-column>
      <el-table-column label="回收订单编号" prop="sendBackOrderId" width="120"></el-table-column>
      <el-table-column label="回收码" prop="recycleCode" width="120"></el-table-column>

      <el-table-column label="旧机状态" prop="statusName" width="120"> </el-table-column>

      <el-table-column label="旧机条码所属销司" prop="saleCompanyName" width="80"></el-table-column>

      <el-table-column label="渠道来源" prop="salePlatformName" width="80"></el-table-column>

      <el-table-column label="承运商" prop="transportCompany" width="80"></el-table-column>

      <el-table-column label="省" prop="warehouseAddrProvName" width="80"></el-table-column>
      <el-table-column label="市" prop="warehouseAddrCityName" width="80"></el-table-column>

      <el-table-column label="回收完成时间" prop="recoveryCompleteDateName" width="140">
        <template slot-scope="scope">{{ scope.row.recoveryCompleteDateName }}</template>
      </el-table-column>

      <el-table-column label="再生资源入库时间" prop="warehousingDateName" width="140"> </el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
          <el-button type="text" v-show="scope.row.settlementStatus === 1 && Number(scope.row.status) > 10200" @click="setSettlementStatus(scope.row)">结算</el-button>
          <el-button type="text" @click="goConfirm(scope.row)" v-if="scope.row.status == '10201' && scope.row.wmsFlag == 1 && scope.row.sourceWorkOrderNo"
            >再生资源已入库</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.rows"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <commonBath
      ref="batchCommonRef"
      @opera-success="getList"
      :errUrl="'/autoapp-default-server-recovery/api/oldMachineRecovery/downLoadSettlementFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/oldMachineRecovery/downLoadSettlementTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/oldMachineRecovery/importSettlementInfo'"
      :title="'批量结算'"
      :uploadTitle="'导入结算'"
    ></commonBath>

    <storageImportResultDialog ref="storageImportResultDialogRef"></storageImportResultDialog>
  </div>
</template>
<script>
import commonBath from './components/commonBath.vue'

import {
  getOldMachineList,
  findAllProvince,
  findAllCity,
  getPartner,
  getRegion,
  settlementOrder,
  salePlatformMap,
  getAppraisalNodeEnumsMap,
  exportSettlementList,
  downSettlementList
} from '@/api/oldForNew'
import storageImportResultDialog from './components/StorageImportResultDialog'
import fileUpload from './components/FileUpload'
import { orderTypeOption, salePlatformType } from './mixin.js'
import BatchSettleStatus from './components/BatchSettleStatus.vue'

export default {
  name: 'searchOld',
  components: {
    commonBath,
    storageImportResultDialog,
    fileUpload
  },
  data() {
    return {
      workerAppraisalTime: [],
      createdTime: [],
      completeTime: [],
      list: [],
      total: null, //列表总条数
      listLoading: false,
      search: {
        sourceWorkOrderNo: null,
        workOrderId: null, //工单编号
        oldBarcode: null, //旧机条码
        // oldMachineBrand: null, //旧机品牌
        engineerOldMachineBrand: null, //旧机品牌(工程师)
        status: null, //旧机状态
        sendBackOrderId: null, //回收订单编号
        startAppraisalTime: null, //工程师鉴定时间-开始
        endAppraisalTime: null, //工程师鉴定时间-结束
        startCreatedDate: null, //创建时间-开始
        endCreatedDate: null, //创建时间-结束
        startRecoveryCompleteDate: null, // 回收完成开始时间
        endRecoveryCompleteDate: null, // 回收完成结束时间
        saleCompanyNo: null, //旧机条码所属销司
        settlementStatus: null, //旧机结算
        salePlatformList: null, //渠道来源
        transportCompanyNo: null, //承运商
        recycleCode: null, //回收码
        regionNo: null, //所属区域
        warehouseAddrProvCode: null, //省
        warehouseAddrCityCode: null, //市
        internalWarehousing: null, //再生资源入库(内)
        externalWarehousing: null, //再生资源入库(外)
        oldMachineSpecMatch: null, //外机规格匹配
        outletsNo: null, //网点编号
        outletsName: null, //网点名称
        recycleName: null, //回收人员
        warehouseName: null, //归集仓名称
        batchNumber: null, // 批次号
        salePlatformType: null, //线上1/线下2
        page: 1, //当前页
        rows: 10
      },

      oldMachineMap: {},
      //工单类型
      orderTypeOption: orderTypeOption,
      //线上/线下渠道
      salePlatformType: salePlatformType,
      provinceList: [], //省份列表
      cityList: [], //市列表
      regionList: [], //区域列表
      carrierOption: [], //承运商选项列表
      regionOption: [], // 销司列表
      hasOldOPtion: { 1: '是', 0: '否' }, //是否有待回收旧机
      oldMachineSpecMatchOption: { 1: '不匹配', 2: '匹配' },
      settlementStatusOption: { 0: '不可结算', 1: '可结算', 2: '已结算' }, //旧机结算状态
      warehousingOption: { 0: '未入库', 1: '已入库' }, //再生资源入库状态
      salePlatformMap: {}, //渠道类型
      countyList: [], //区域列表
      hasOldOPtion: { 1: '是', 0: '否' }, //是否有待回收旧机
      // 上传数据
      upLoadData: '',
      showOtherSearch: false
    }
  },
  async created() {
    this.getList()
    this.getTblProvince()
    this.getPartnerList()
    this.getRegionList()
    this.getSalePlatformMap()
    this.getAppraisalNodeEnumsMap()
  },
  filters: {
    changeStatus(value, optionList) {
      return value ? (optionList.find(item => item.value == value) || {}).label || '' : ''
    },
    copperPipeStatus(value) {
      if (value === 0) return '否'
      if (value === 1) return '是'
      return '--'
    }
  },
  methods: {
    changeWorkerAppraisalTime() {
      if (this.workerAppraisalTime && this.workerAppraisalTime.length) {
        this.setTimeRange(this.workerAppraisalTime, ['startAppraisalTime', 'endAppraisalTime'])
      } else {
        this.search.startAppraisalTime = this.search.endAppraisalTime = null
      }
    },
    changeCreatedTime() {
      if (this.createdTime && this.createdTime.length) {
        this.setTimeRange(this.createdTime, ['startCreatedDate', 'endCreatedDate'])
      } else {
        this.search.startAppraisalTime = this.search.endAppraisalTime = null
      }
    },
    changeCompleteTime() {
      if (this.completeTime && this.completeTime.length) {
        this.setTimeRange(this.completeTime, ['startRecoveryCompleteDate', 'endRecoveryCompleteDate'])
      } else {
        this.search.startAppraisalTime = this.search.endAppraisalTime = null
      }
    },
    getBrandLabel(brand) {
      const brandMap = {
        GREE: '格力品牌',
        OTHER: '非格力品牌'
      }
      return brandMap[brand] || ''
    },
    //获取承运商
    async getPartnerList() {
      let { statusCode, data } = await getPartner()
      if (statusCode == 200) {
        this.carrierOption = data
      }
    },
    //获取销司
    async getRegionList() {
      let { statusCode, data } = await getRegion()
      if (statusCode == 200) {
        const list = data.data || []
        this.regionOption = list.map(item => {
          return {
            label: item.regionName,
            value: item.regionNo
          }
        })
      }
    },
    setTimeRange(timeRange, [startKey, endKey]) {
      if (timeRange && timeRange.length) {
        this.search[startKey] = timeRange[0] + ' 00:00:00'
        this.search[endKey] = timeRange[1] + ' 23:59:59'
      }
    },
    //获取渠道类型
    async getSalePlatformMap() {
      let { statusCode, data } = await salePlatformMap()
      if (statusCode == 200) {
        this.salePlatformMap = data
      }
    },
    //获取旧机状态
    async getAppraisalNodeEnumsMap() {
      let { statusCode, data } = await getAppraisalNodeEnumsMap()
      if (statusCode == 200) {
        this.oldMachineMap = data
      }
    },
    handleSearch() {
      this.search.page = 1
      this.getList()
    },

    async getList() {
      if (this.workerAppraisalTime && this.workerAppraisalTime.length) {
        ;[] = this.workerAppraisalTime
        this.setTimeRange(this.workerAppraisalTime, ['startAppraisalTime', 'endAppraisalTime'])
      } else {
        this.search.startAppraisalTime = this.search.endAppraisalTime = null
      }
      if (this.createdTime && this.createdTime.length) {
        ;[this.search.startCreatedDate, this.search.endCreatedDate] = this.createdTime
        this.setTimeRange(this.createdTime, ['startCreatedDate', 'endCreatedDate'])
      } else {
        this.search.startCreatedDate = this.search.endCreatedDate = null
      }
      // 回收完成时间
      if (this.completeTime && this.completeTime.length) {
        ;[this.search.startRecoveryCompleteDate, this.search.endRecoveryCompleteDate] = this.completeTime
        this.setTimeRange(this.completeTime, ['startRecoveryCompleteDate', 'endRecoveryCompleteDate'])
      } else {
        this.search.startRecoveryCompleteDate = this.search.endRecoveryCompleteDate = null
      }
      if (this.search.salePlatformList) {
        this.search.salePlatformList = [this.search.salePlatformList]
      }

      let { statusCode, data } = await getOldMachineList(this.search)
      if (statusCode == 200) {
        this.list = data.records
        this.total = data.total || 0
      } else {
        this.list = []
      }
    },

    resetForm() {
      this.search = this.$options.data().search
      this.completeTime = []
      this.workerAppraisalTime = []
      this.createdTime = []
    },

    handleSizeChange(val) {
      this.search.page = 1
      this.search.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    goDetail(row) {
      if (row.id) {
        this.$router.push({
          path: '/oldForNewService/searchOldDetailNew',
          // id 用于展示旧机记录，工单编号用于回查旧机信息
          query: { id: row.id, sourceWorkOrderNo: row.sourceWorkOrderNo || '' }
        })
      }
    },
    //确认-再生资源已入库
    goConfirm(row) {
      const params = {
        sourceWorkOrderNoList: [row.sourceWorkOrderNo],
        oldInternalBarcode: row.oldInternalBarcode,
        oldExternalBarcode: row.oldExternalBarcode
      }

      if (row.sourceWorkOrderNo) {
        this.$dialog({
          title: '再生资源入库确认',
          content: '请确认，再生资源仓库已接收',
          cancel_buttton: '否',
          ok_buttton: '是',
          width: '400px',
          footBtn: 'card',
          dialogType: 'sighicon',
          onOk: () => {
            this.HttpService.post(`autoapp-default-server-recovery/api/oldMachineRecovery/oldMachineInbound`, params).then(res => {
              if (res.statusCode === 200) {
                this.$message.success('已确认')
                this.getList()
              } else {
                const tipMsg = res.message || '操作失败，请联系管理员'
                this.$message.error(tipMsg)
              }
            })
          },
          onCancel: () => {
            console.log('cancel')
          }
        })
      }
    },
    async getPrintDetail(
      salePlatformType,
      transportCompanyNo,
      recycleCode,
      regionNo,
      settlementStatus,
      startAppraisalTime,
      endAppraisalTime,
      sourceWorkOrderNo,
      sendBackOrderId,
      startRecoveryCompleteDate,
      endRecoveryCompleteDate,
      startCreatedDate,
      endCreatedDate
    ) {
      const params = {
        salePlatformType: salePlatformType,
        transportCompanyNo: transportCompanyNo,
        recycleCode: recycleCode,
        regionNo: regionNo,
        startAppraisalTime: startAppraisalTime,
        endAppraisalTime: endAppraisalTime,
        sourceWorkOrderNo: sourceWorkOrderNo,
        sendBackOrderId: sendBackOrderId,
        startRecoveryCompleteDate,
        endRecoveryCompleteDate,
        startCreatedDate,
        endCreatedDate,
        settlementStatus: 1
      }
      let { statusCode, message } = await downSettlementList(params)

      if (statusCode === 200) {
        const queryString = new URLSearchParams({
          salePlatformType: this.search.salePlatformType,
          transportCompanyNo: this.search.transportCompanyNo,
          recycleCode: this.search.recycleCode,
          regionNo: this.search.regionNo,
          startAppraisalTime: this.workerAppraisalTime.length ? this.workerAppraisalTime[0] : '',
          endAppraisalTime: this.workerAppraisalTime.length ? this.workerAppraisalTime[1] : '',
          sourceWorkOrderNo: this.search.sourceWorkOrderNo || '',
          sendBackOrderId: this.search.sendBackOrderId || '',
          startRecoveryCompleteDate: this.completeTime.length ? this.completeTime[0] : '',
          endRecoveryCompleteDate: this.completeTime.length ? this.completeTime[1] : '',
          startCreatedDate: this.createdTime.length ? this.createdTime[0] : '',
          endCreatedDate: this.createdTime.length ? this.createdTime[1] : ''
        }).toString()

        window.open(`/oldForNewService/searchOldDetail?${queryString}`, '_blank')
        window.open(`/oldForNewService/searchOldSettlementDetail?${queryString}`, '_blank')

        this.exportSettlementList({
          salePlatformType,
          transportCompanyNo,
          recycleCode,

          regionNo,
          settlementStatus,
          startAppraisalTime,
          endAppraisalTime,
          sourceWorkOrderNo,
          sendBackOrderId,
          startRecoveryCompleteDate,
          endRecoveryCompleteDate,
          startCreatedDate,
          endCreatedDate
        })
      } else {
        this.$message.warning({
          message: message
        })
      }
    },
    //获取省份列表
    async getTblProvince() {
      this.search.warehouseAddrCityCode = ''

      let { statusCode, data } = await findAllProvince()
      if (statusCode === 200) {
        this.provinceList = (data || []).filter(item => item != null)
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.search.warehouseAddrCityCode = ''
      if (!this.search.warehouseAddrProvCode) {
        return
      }
      let { statusCode, data } = await findAllCity(this.search.warehouseAddrProvCode)
      if (statusCode === 200) {
        this.cityList = (data || []).filter(item => item != null)
      }
    },
    //更改结算状态
    setSettlementStatus(row) {
      if (row.sourceWorkOrderNo) {
        this.$dialog({
          title: '已结算确认',
          content: '请确认旧机结算',
          cancel_buttton: '取消',
          ok_buttton: '确认',
          width: '400px',
          footBtn: 'card',
          dialogType: 'sighicon',
          onOk: () => {
            this.confirmSettlement(row)
          },
          onCancel: () => {
            console.log('cancel')
          }
        })
      }
    },
    //批量已结算
    BatchSettleStatus() {
      this.$refs.batchCommonRef.openDialog()
    },
    //确认更改旧机结算状态
    async confirmSettlement(row) {
      let params = { sourceWorkOrderNoList: [row.sourceWorkOrderNo], oldInternalBarcode: row.oldInternalBarcode, oldExternalBarcode: row.oldExternalBarcode }
      let { statusCode } = await settlementOrder(params)
      if (statusCode == 200) {
        this.$message.success('操作成功')
        this.getList()
      }
    },
    //导出
    exportExcel() {
      let url = '/autoapp-default-server-recovery/api/oldMachineRecovery/export/oldMachineDetailList'
      let title = '旧机查询列表导出'

      this.HttpService.post(url, this.search).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 导入批量再生资源已入库表
    importExcel(item) {
      this.upLoadData = item
      let formData = new FormData()
      formData.append('file', this.upLoadData.file)
      let url = `/autoapp-default-server-recovery/api/oldMachineRecovery/importInboundInfo`
      this.HttpService.post(url, formData).then(res => {
        if (res.statusCode === 200) {
          if (res.data) {
            console.log('入库失败了', res.data)
            let downloadId = res.data
            this.$refs.storageImportResultDialogRef.openDialog(downloadId)
          } else {
            this.$message.success('批量再生资源已入库成功')
            this.getList()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 下载批量入库模板
    downloadBatchStorageTemplate() {
      let url = `/autoapp-default-server-recovery/api/oldMachineRecovery/downLoadInboundTemplate`
      let title = '批量入库模板'
      this.global.exportExcel(url, {}, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    //结算单导出入口
    openTable() {
      //将结算单状态设成已结算
      this.search.settlementStatus = '1'
      //线上线下渠道类型
      //承运商
      //所属区域
      const {
        salePlatformType,
        transportCompanyNo,
        recycleCode,
        regionNo,
        settlementStatus,
        startAppraisalTime,
        endAppraisalTime,
        sourceWorkOrderNo,
        sendBackOrderId,
        startRecoveryCompleteDate,
        endRecoveryCompleteDate,
        startCreatedDate,
        endCreatedDate
      } = this.search

      if (salePlatformType && transportCompanyNo && regionNo && settlementStatus) {
        this.getPrintDetail(
          salePlatformType,
          transportCompanyNo,
          recycleCode,
          regionNo,
          settlementStatus,
          startAppraisalTime,
          endAppraisalTime,
          sourceWorkOrderNo,
          sendBackOrderId,
          startRecoveryCompleteDate,
          endRecoveryCompleteDate,
          startCreatedDate,
          endCreatedDate
        )
      } else {
        this.$message.warning('请先筛选线上/线下渠道、承运商、网点所属销司')
      }
    },
    //下载结算单
    async exportSettlementList(params) {
      let url = `/autoapp-default-server-recovery/api/oldMachineRecovery/exportSettlementList`
      let title = '结算单'
      this.global.exportExcel(url, params, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    changeSalePlatformType() {
      if (this.search.salePlatformType) {
        this.search.salePlatformList = null
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  display: flex;
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
.batch-storage-button {
  margin-left: 10px;
  margin-right: 10px;
}
.show-other-search {
  display: flex;
  // justify-content: flex-end;
  padding-bottom: 16px;
  .show-other-search-btn {
    cursor: pointer;
    color: #00b882;
    .show-btn-icon {
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/searchOld.vue